import { useSelector } from "react-redux";


export const Footer = () => {

  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  
  
  return (
    <footer id="footer">
      <div className="container">
        Copyright by {(subdomain_name === "vidwise") ?'VidWise':(subdomain_name === "nicheflick") ?'Nicheflicks':'VidCraft AI'} 2025. All Rights Reserved &nbsp;&nbsp;
        {/* <NavLink to="#">Cookies Policy</NavLink>
        <NavLink to="#">Disclaimers</NavLink> */}
      </div>
    </footer>
  );
};
